import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

const LOGO_URL = 'https://customer-assets-4nw71qhi.emergentagent.net/job_48ccfe14-9a78-4511-9adb-e31d4f86bb3c/artifacts/qhjao7c6_ChatGPT%20Image%20Jul%2027%2C%202026%2C%2011_59_00%20PM.png';

const columns = [
  {
    title: 'The Law',
    links: [
      { to: '/dpdpa-act', label: 'DPDPA Act, 2023' },
      { to: '/dpdp-rules', label: 'DPDP Rules, 2025' },
      { to: '/case-laws', label: 'Case Laws' },
      { to: '/resources', label: 'Resources & Glossary' },
    ],
  },
  {
    title: 'Compliance',
    links: [
      { to: '/compliance-guides', label: 'Compliance Guides' },
      { to: '/templates', label: 'Templates' },
      { to: '/consent-manager', label: 'Consent Manager' },
      { to: '/compliance-assessment', label: 'Compliance Assessment' },
    ],
  },
  {
    title: 'Read',
    links: [
      { to: '/blog', label: 'Privacy Blog' },
      { to: '/news', label: 'DPDPA News' },
    ],
  },
  {
    title: 'Ecosystem',
    links: [
      { href: 'https://complyzen.in/academy', label: 'Academy' },
      { href: 'https://complyzen.in/products/zendpo', label: 'ZenDPO Compliance Suite' },
      { href: 'https://complyzen.in/contact', label: 'Book Consultation' },
    ],
  },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-navy text-white pt-24 pb-10 px-6 sm:px-10 lg:px-16 border-t border-white/10">
    <div className="max-w-7xl mx-auto">
      <div className="flex flex-col lg:flex-row justify-between gap-14 pb-16 border-b border-white/10">
        <div className="max-w-md">
          <Link to="/" className="flex items-center gap-3 mb-6">
            <img src={LOGO_URL} alt="dpdpa.blog" className="w-9 h-9" />
            <span className="font-serif text-2xl">dpdpa<span className="text-saffron">.blog</span></span>
          </Link>
          <p className="text-white/60 text-sm leading-relaxed">
            An independent knowledge hub for India's Digital Personal Data Protection Act, 2023 and the DPDP Rules, 2025 — written in plain language for founders, DPOs, lawyers and compliance teams.
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-10 flex-1">
          {columns.map((col) => (
            <div key={col.title}>
              <p className="font-mono text-xs uppercase tracking-[0.2em] text-white/40 mb-4">{col.title}</p>
              <ul className="space-y-3">
                {col.links.map((l) =>
                  l.to ? (
                    <li key={l.label}>
                      <Link to={l.to} data-testid={`footer-link-${l.label.replace(/\s/g, '-').toLowerCase()}`} className="text-sm text-white/70 hover:text-cyan transition-colors">
                        {l.label}
                      </Link>
                    </li>
                  ) : (
                    <li key={l.label}>
                      <a href={l.href} data-testid={`footer-link-${l.label.replace(/\s/g, '-').toLowerCase()}`} className="text-sm text-white/70 hover:text-cyan transition-colors flex items-center gap-1">
                        {l.label} <ArrowUpRight size={12} />
                      </a>
                    </li>
                  )
                )}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <div className="pt-10 flex flex-col sm:flex-row justify-between gap-4 text-white/40 text-xs">
        <p>© {new Date().getFullYear()} dpdpa.blog · This site provides general information on the DPDPA and does not constitute legal advice.</p>
        <p>An independent DPDPA knowledge resource</p>
      </div>
      <p data-testid="footer-disclaimer" className="text-white/30 text-[11px] leading-relaxed text-center mt-6 pt-6 border-t border-white/5">
        Developed and maintained by <a href="https://complyzen.in" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-cyan transition-colors">ComplyZen Security Solutions Pvt Ltd</a> as a public-interest initiative to spread awareness of the DPDPA and data privacy in India.
      </p>
    </div>
  </footer>
);
